import React, { useEffect, useState } from "react";
import { about1, logo, about2, about3, footer1, footer2, footer3, footer4, footer5, footer6, footer7, footer8, footer9, footer10, footer, footerMobile, subMenuContact2 } from '../../assets/images';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom"; // React Router importları
import axios from "axios";

const Footer = () => {

  const { t, i18n } = useTranslation();

   const location = useLocation();
        const [item, setItem] = useState([]);
          const [isLoading, setIsLoading] = useState(true);
  
      useEffect(() => {
        getProducts();
      }, []);
    
      const getProducts = async () => {
        try {
          const response = await axios.get(
            `https://www.adb.az/arash/settings.php`,
            { withCredentials: false }
          );
          console.log(response.data.data);
          setItem(response.data.data[0]);
          setIsLoading(false);
        } catch (error) {
          console.error("Error fetching products:", error);
        }
      };

  return (
   <div className="bg-[#FBFBFB] pt-[100px] md:pt-[120px] ">
    <div className="bg-[white] ">
    <div className="max-w-containerSm md:max-w-container mx-auto">
      <div className="pt-[48px] pb-[22px] flex flex-col items-center text-[#1C1C1C]">
    <img className="w-[62px]" src={logo}></img>
    <p className="mt-[24px] text-center">Peşəkar İqlim və Havalandırma Həlləri – Rahatlığınız Bizimlə!</p>
    <nav className="flex flex-col md:flex-row gap-4 text-[14px] md:text-[16px] mt-8 text-center">
  <a href="/">Ana səhifə</a>
  <a href="/services">Xidmətlər</a>
  <a href="/projects">Layihələr</a>
  <a href="/partners">Tərəfdaşlıq</a>
  <a href="/news">Xəbərlər</a>
  <a href="/subpodrat">Subpodratçı olun</a>
  <a href="/careers">Karyera</a>
  <a href="/contact">Əlaqə</a>
</nav>

    <nav className="md:flex gap-8 mt-8">
     <div className='flex gap-2'>
         <img className='h-5 w-5' src={footer1}></img>
        <p className='text-[14px]'>Babək prospekti 38a AZ1074</p>
        </div>
        <div className='flex gap-2'>
            <img className='h-5 w-5' src={footer2}></img>
           <p className='text-[14px]'>012 424 34 55; 012 424 34 56</p>
           </div>
    </nav>
    <div className="w-full h-[1px] bg-[#CFCFCF] mt-[56px]">
    </div>
    <div className="md:flex justify-between text-[14px] mt-5 text-center w-full">
  <p>akond.az © Bütün hüquqlar qorunur.</p>
  <p>Sayt hazırlandı: <a target="_blank" href="https://www.birsayt.az">Birsayt.az</a></p>
    </div>
      </div>
   </div>
   </div>
   </div>
  );
}; 

export default Footer;